import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
	AppBar,
	Grid,
	Tabs,
	Tab,
	Typography,
	Box,
	Button,
	TextField,
} from '@material-ui/core';
import SearchField from './SearchField';

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role='tabpanel'
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box p={2}>
					<Typography component='div'>{children}</Typography>
				</Box>
			)}
		</div>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
};

function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		'aria-controls': `simple-tabpanel-${index}`,
	};
}

const useStyles = makeStyles(theme => ({
	root: {
		flexGrow: 1,
		backgroundColor: theme.palette.background.paper,
		minWidth: 300,
	},
}));

export default function SimpleTabs({ setItem, handleSearchNames, handleSearchNationalId }) {
	const classes = useStyles();
	const [value, setValue] = React.useState(0);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	return (
		<div className={classes.root}>
			<AppBar position='static'>
				<Tabs
					value={value}
					onChange={handleChange}
					variant='fullWidth'
					aria-label='simple tabs example'
				>
					<Tab label='Names' {...a11yProps(0)} />
					<Tab label='National ID' {...a11yProps(1)} />
				</Tabs>
			</AppBar>
			<TabPanel value={value} index={0}>
				<SearchField
					item='Names'
					onClick={handleSearchNames}
					setItem={setItem}
				/>
			</TabPanel>
			<TabPanel value={value} index={1}>
				<SearchField
					item='National ID'
					onClick={handleSearchNationalId}
					setItem={setItem}
				/>
			</TabPanel>
		</div>
	);
}
